import axiosInstance from "api/axiosInstance"

import { provinceDashboardAction } from "./province-dashboard-slice"

import exportAxiosInstance from "api/exportAxiosInstance"

import FileSaver from "file-saver"

import {
  buildFilterParams,
  buildFlatFilterParams,
} from "utils/providerDashboardFilters"

// Get Province Stock

export const getProvinceStock = params => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceStock({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-stock`, dashboardRequestConfig(params))

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceStock({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceStock({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Ips

export const getProvinceIps = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceIps({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-ips`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceIps({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceIps({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Item Categories

export const getProvinceItemCategories =
  (commodityClassificationId = null) =>
  dispatch => {
    dispatch(
      provinceDashboardAction.setProvinceItemCategories({
        loading: true,

        error: null,

        data: null,
      })
    )

    axiosInstance

      .get(`/v1/get-province-itemCategories`, {
        params: commodityClassificationId
          ? { commodity_classification_id: commodityClassificationId }
          : {},
      })

      .then(respnose => {
        dispatch(
          provinceDashboardAction.setProvinceItemCategories({
            loading: false,

            error: null,

            data: respnose?.data,
          })
        )
      })

      .catch(error => {
        dispatch(
          provinceDashboardAction.setProvinceItemCategories({
            loading: false,

            error: error?.response,

            data: null,
          })
        )

        console.log(error)
      })
  }

// Get Province Unit Classification

export const getProvinceCommodityClassifications = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceCommodityClassifications({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-commodity-classifications`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceCommodityClassifications({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceCommodityClassifications({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Currencies

export const getProvinceCurrencies = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceCurrencies({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-currencies`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceCurrencies({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceCurrencies({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Items

export const getProvinceItems = id => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceItems({
      loading: true,

      error: null,

      data: [],
    })
  )

  axiosInstance

    .get(`/v1/get-province-items/${id}`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceItems({
          loading: false,

          error: error?.response,

          data: [],
        })
      )

      console.log(error)
    })
}

// Get Province In Items

export const getProvinceInItems = params => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceInItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-stock-ins`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceInItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceInItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Out Items

export const getProvinceOutItems = params => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceOutItems({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-stock-outs`, { params: params ? params : {} })

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceOutItems({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceOutItems({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Warehouses

export const getProvinceWarehouses = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceWarehouses({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-warehouses`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceWarehouses({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceWarehouses({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Provinces

export const getProvinceProvinces = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceProvinces({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-provinces`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceProvinces({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceProvinces({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Provider

export const getProvinceProvider = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceProvider({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-providers`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceProvider({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceProvider({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Facilities

export const getProvinceFacilities = id => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceFacilities({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-facilities/${id}`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceFacilities({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceFacilities({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Get Province Projects

export const getProvinceProjects = () => dispatch => {
  dispatch(
    provinceDashboardAction.setProvinceProjects({
      loading: true,

      error: null,

      data: null,
    })
  )

  axiosInstance

    .get(`/v1/get-province-projects`)

    .then(respnose => {
      dispatch(
        provinceDashboardAction.setProvinceProjects({
          loading: false,

          error: null,

          data: respnose?.data,
        })
      )
    })

    .catch(error => {
      dispatch(
        provinceDashboardAction.setProvinceProjects({
          loading: false,

          error: error?.response,

          data: null,
        })
      )

      console.log(error)
    })
}

// Export Province Stock

export const exportProvinceStock =
  (params = {}) =>
  dispatch => {
    dispatch(
      provinceDashboardAction.setExportStatus({
        loading: true,

        error: null,
      })
    )

    exportAxiosInstance

      .get("/v1/export-province-stock", {
        params: params,
      })

      .then(response => {
        if (response) {
          const dataBlob = new Blob([response?.data], {
            type: "application/pdf,",
          })

          FileSaver.saveAs(
            dataBlob,

            `Province-In-${Math.random().toString()}.xlsx`
          )

          dispatch(
            provinceDashboardAction.setExportStatus({
              loading: false,

              error: null,
            })
          )
        }
      })

      .catch(error => {
        dispatch(
          provinceDashboardAction.setExportStatus({
            loading: false,

            error: error?.response?.errors,
          })
        )

        console.log(error)
      })
  }

// ====== Realtime Dashboard Actions ======

const dashboardRequestConfig = (filters, extraParams = {}) => ({
  params: {
    ...buildFilterParams(filters),

    ...extraParams,
  },
})

const setRealtimeLoading = key =>
  provinceDashboardAction[`setRealtime${key}`]({
    loading: true,
    error: null,
    data: null,
  })

const setRealtimeSuccess = (key, response) =>
  provinceDashboardAction[`setRealtime${key}`]({
    loading: false,

    error: null,

    data: response?.data?.data,
  })

const setRealtimeError = (key, error) =>
  provinceDashboardAction[`setRealtime${key}`]({
    loading: false,

    error: error?.response,

    data: null,
  })

export const fetchProvinceRealtimeDashboardConfig =
  (filters, isCascadeRefresh = false) =>
  (dispatch, getState) => {
    if (isCascadeRefresh) {
      const existing =
        getState().provinceDashboard.realtime?.config?.data ?? null
      dispatch(
        provinceDashboardAction.setRealtimeConfig({
          loading: true,
          error: null,
          data: existing,
        })
      )
    } else {
      dispatch(setRealtimeLoading("Config"))
    }

    axiosInstance

      .get("/v1/province/dashboard/config", dashboardRequestConfig(filters))

      .then(response => dispatch(setRealtimeSuccess("Config", response)))

      .catch(error => dispatch(setRealtimeError("Config", error)))
  }

export const fetchSectionChartData =
  ({ filters = {}, section, chartType, dataset = "stock" } = {}) =>
  dispatch => {
    if (!section || !chartType) return

    dispatch(
      provinceDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    const params = dashboardRequestConfig(filters, { dataset })

    axiosInstance

      .get(`/v1/province/dashboard/charts/${chartType}`, params)

      .then(response => {
        const payload = response?.data?.data || {}

        dispatch(
          provinceDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload.data || [],

            dataset,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        dispatch(
          provinceDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }

export const exportProvinceRealtimeDashboard =
  ({ filters = {}, dataset = "stock", format = "xlsx" } = {}) =>
  dispatch => {
    dispatch(
      provinceDashboardAction.setRealtimeExportState({
        loading: true,
        error: null,
      })
    )

    const exportParams = dashboardRequestConfig(filters, { dataset })

    return exportAxiosInstance

      .get(`/v1/province/dashboard/export/${format}`, {
        ...exportParams,

        responseType: "blob",
      })

      .then(response => {
        const extension =
          format === "csv" ? "csv" : format === "pdf" ? "pdf" : "xlsx"

        const mimeType =
          format === "csv"
            ? "text/csv"
            : format === "pdf"
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

        FileSaver.saveAs(
          new Blob([response.data], { type: mimeType }),

          `province-dashboard-${dataset}.${extension}`
        )

        dispatch(
          provinceDashboardAction.setRealtimeExportState({
            loading: false,
            error: null,
          })
        )

        return Promise.resolve()
      })

      .catch(error => {
        dispatch(
          provinceDashboardAction.setRealtimeExportState({
            loading: false,

            error: error?.response,
          })
        )

        return Promise.reject(error)
      })
  }

let provinceMapRequestSequence = 0

export const fetchSectionMapData =
  ({ filters = {}, type = "receipt" } = {}) =>
  dispatch => {
    const requestId = ++provinceMapRequestSequence

    const section = "map"

    dispatch(
      provinceDashboardAction.setSectionChartData({
        section,

        loading: true,

        error: null,

        data: null,

        hasData: false,
      })
    )

    axiosInstance

      .get(`/v1/province/province-map/${type}`, dashboardRequestConfig(filters))

      .then(response => {
        if (requestId !== provinceMapRequestSequence) {
          return
        }

        const payload = response?.data?.data || {}

        dispatch(
          provinceDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: null,

            data: payload,

            type,

            hasData: Boolean(payload.has_data),
          })
        )
      })

      .catch(error => {
        if (requestId !== provinceMapRequestSequence) {
          return
        }

        dispatch(
          provinceDashboardAction.setSectionChartData({
            section,

            loading: false,

            error: error?.response,

            data: null,

            hasData: false,
          })
        )
      })
  }
